import { useState, useEffect } from 'react';
import PhoneMaskInput from '@components/PhoneMaskInput';
import TextField from '@components/TextField';
import Select from '@components/Select';
import Checkbox from '@components/Checkbox';
import { apiClient } from '@services/api';
import SelectSearch from 'react-select'
import { darkSelectStyles, darkLabelStyle } from '@utils/darkSelectStyles';

const ClientForm = (props) => {
  const [partners, setPartners] = useState([])
  let [regions, setRegions] = useState([]);
  // 'none' | 'seller' | 'agency'
  const [partnerMode, setPartnerMode] = useState('none')
  const [partnerSearch, setPartnerSearch] = useState('')
  const [selectedPartner, setSelectedPartner] = useState(null)

  const getRegionData = () => {
    apiClient.httpInstance.get('/regions').then(response => {
      if (response.status === 200) {
        let regions = response.data.sort(function (a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        })
        setRegions(regions);
      }
    });
  }

  const getPartners = () => {
    apiClient
      .httpInstance.get('/agencies_sellers').then(response => {
        if (response.status === 200) {
          const partners = response.data.filter(obj => obj.email !== null && obj.email !== "").map(obj => ({
            ...obj,
            nameSelect: `${obj.name ? obj.name : obj.email}`
          }))
          setPartners(partners);
        }
      });
  }

  const getPartner = (ev) => {
    let email = ev.target.value
    const partner = partners.find((obj) => obj.email === email)
    const url = partner.type === 'agency' ? `/agencies/${partner.id}` : `/partner_sellers/${partner.id}`
    apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        if (partner.type === 'seller' || partner.type === 'agency' || partner.type === 'partner') {
          const data = {
            partner: response.data.id,
            partnerEmail: response.data.email,
            partner_seller_id: response.data.id,
            partner_type: partner.type
          }
          props.changeClientByPartner(data)
        } else if (props.client.email && props.client.email !== props.client.partnerEmail) {
          const data = {
            partner: response.data.id,
            partnerEmail: response.data.email,
            partner_seller_id: response.data.id,
            partner_type: partner.type
          }
          props.changeClientByPartner(data)
        } else {
          const data = {
            addresses: response.data.address,
            email: response.data.email,
            name: props.client.name,
            phone: props.client.phone,
            document: props.client.document,
            customer_id: null,
            observations: props.client.observations,
            hotel_name: props.client.hotel_name,
            hotel_address: props.client.hotel_address,
            customer_language: null,
            room_number: props.client.room_number,
            partner: response.data.id,
            partnerEmail: response.data.email,
            havePartner: props.client.havePartner,
            partner_seller_id: response.data.id,
            partner_type: partner.type
          }
          props.changeClientByEmail(data)
        }
      }
    });
  }

  const changePartnerMode = (mode) => {
    setPartnerMode(mode)
    setPartnerSearch('')
    setSelectedPartner(null)
    // Limpa parceiro no estado do cliente (não apaga campos digitados)
    props.changeClientByPartner({
      partner: null,
      partnerEmail: null,
      partner_seller_id: null,
      partner_type: null
    })
  }

  const selectPartner = (partner) => {
    setSelectedPartner(partner)
    setPartnerSearch('')

    if (partner.type === 'agency') {
      // Busca dados completos da agência e preenche os campos do cliente
      apiClient.httpInstance.get(`/agencies/${partner.id}`).then(response => {
        if (response.status === 200) {
          const agency = response.data
          props.changeClientByEmail({
            addresses: props.client.addresses || [],
            customer_id: null,
            customer_language: props.client.customer_language,
            document: props.client.document,
            email: agency.email || '',
            name: agency.name || '',
            phone: agency.telephone || props.client.phone || '',
            hotel_name: props.client.hotel_name,
            hotel_address: props.client.hotel_address,
            room_number: props.client.room_number,
            observations: props.client.observations,
            havePartner: true,
            partner: agency.id,
            partnerEmail: agency.email,
            partner_seller_id: agency.id,
            partner_type: 'agency'
          })
        }
      })
    } else {
      props.changeClientByPartner({
        partner: partner.id,
        partnerEmail: partner.email,
        partner_seller_id: partner.id,
        partner_type: 'seller'
      })
    }
  }

  // Busca o cadastro do cliente pelo e-mail e preenche hotel/endereços/idioma.
  // Extraído p/ poder ser chamado tanto no onChange do campo quanto no mount
  // (quando o e-mail já vem preenchido — ex: orçamento importado — e o onChange
  // nunca dispara, então o hotel não era puxado).
  const fetchClientByEmail = (value) => {
    apiClient
      .httpInstance.get(`/customer_by_email?email=${value}`)
      .then(response => {
        if (response.status === 200) {
          const data = {
            addresses: response.data.address,
            email: response.data.email,
            name: response.data.name,
            phone: response.data.phone,
            document: response.data.document,
            customer_id: response.data.id,
            observations: response.data.observations,
            hotel_name: response.data.hotel,
            hotel_address: response.data.hotel_address,
            room_number: response.data.room_number,
            customer_language: response.data.language,
            partner: props.client.partner,
            partnerEmail: props.client.partnerEmail,
            havePartner: props.client.havePartner,
            partner_seller_id: props.client.partner_seller_id,
            partner_type: props.client.partner_type
          }
          props.changeClientByEmail(data)
        }
      })
      .catch(error => {
        //props.clearAdresses()
      })
  }

  const getClientByEmail = (ev) => {
    const value = ev.target.value
    props.changeClient(ev)
    if (value.length > 0) {
      fetchClientByEmail(value)
    } else {
      props.changeClientByEmail({
        addresses: [{
          id: '',
          region_id: '',
          region_name: '',
          customer_id: '',
          hotel: '',
          hotel_address: '',
          room_number: ''
        },
        {
          id: '',
          region_id: '',
          region_name: '',
          customer_id: '',
          hotel: '',
          hotel_address: '',
          room_number: ''
        }],
        customer_id: null,
        email: null,
        document: null,
        name: null,
        phone: null,
        hotel_name: null,
        hotel_address: null,
        room_number: null,
        customer_language: null,
        observations: null,
        havePartner: props.client.havePartner,
        partner: props.client.partner,
        partnerEmail: props.client.partnerEmail,
        derived: false,
        partner_type: props.client.partner_type,
        partner_seller_id: props.client.partner_seller_id
      })
    }
  }

  useEffect(() => {
    getPartners()
    getRegionData()
    // Se o e-mail já veio preenchido (ex: orçamento importado) e o hotel ainda não
    // foi carregado, busca o cadastro automaticamente — senão o hotel/endereços do
    // cliente existente não eram puxados (o onChange do campo nunca dispara).
    if (props.client?.email && !props.client?.hotel_name) {
      fetchClientByEmail(props.client.email)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <>
    <div className="p-4 text-lg border-b border-solid text-blue font-poppins border-lightgray">
      <span>Cadastro</span>
    </div>
    <div className="px-4 py-3 border-b border-solid font-poppins border-lightgray">
      <p className="pb-3 font-bold">Parceiro</p>
      <div className="flex flex-wrap gap-2 pb-2">
        {[
          { key: 'none', label: 'Sem parceiro' },
          { key: 'seller', label: 'Vendedor parceiro' },
          { key: 'agency', label: 'Agência parceira' }
        ].map(opt => (
          <button
            key={opt.key}
            type="button"
            onClick={() => changePartnerMode(opt.key)}
            style={{
              padding: '7px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontFamily: 'inherit',
              cursor: 'pointer',
              marginRight: '8px',
              border: partnerMode === opt.key ? '1px solid #1f4f91' : '1px solid #c4cdd5',
              background: partnerMode === opt.key ? '#1f4f91' : 'transparent',
              color: partnerMode === opt.key ? '#fff' : 'inherit',
              fontWeight: partnerMode === opt.key ? 600 : 400
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {partnerMode !== 'none' && (
        <div className="pt-2">
          {selectedPartner ? (
            <div
              className="flex items-center justify-between"
              style={{ border: '1px solid #c4cdd5', borderRadius: '10px', padding: '10px 14px' }}
            >
              <div>
                <span className="font-bold" style={{ fontSize: '14px' }}>{selectedPartner.name || selectedPartner.email}</span>
                {selectedPartner.email && (
                  <span style={{ fontSize: '12px', marginLeft: '8px', opacity: 0.7 }}>({selectedPartner.email})</span>
                )}
                <span style={{ fontSize: '11px', marginLeft: '8px', opacity: 0.6 }}>
                  {selectedPartner.type === 'agency' ? 'agência' : 'vendedor'}
                </span>
              </div>
              <button
                type="button"
                onClick={() => changePartnerMode(partnerMode)}
                style={{ background: 'transparent', border: '1px solid #d9534f', borderRadius: '6px', color: '#d9534f', padding: '4px 12px', fontSize: '12px', cursor: 'pointer' }}
              >
                Trocar
              </button>
            </div>
          ) : (
            <>
              <input
                placeholder={partnerMode === 'agency' ? 'Buscar agência por nome ou e-mail...' : 'Buscar vendedor por nome ou e-mail...'}
                value={partnerSearch}
                onChange={(e) => setPartnerSearch(e.target.value)}
                style={{
                  width: '100%',
                  border: '1px solid #c4cdd5',
                  borderRadius: '10px',
                  padding: '9px 14px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  outline: 'none',
                  background: 'transparent',
                  color: 'inherit'
                }}
              />
              <div style={{ maxHeight: '180px', overflowY: 'auto', marginTop: '6px' }}>
                {partners
                  .filter(o => o.type === partnerMode)
                  .filter(o => !partnerSearch
                    || (o.nameSelect || '').toLowerCase().includes(partnerSearch.toLowerCase())
                    || (o.email || '').toLowerCase().includes(partnerSearch.toLowerCase()))
                  .slice(0, 30)
                  .map(o => (
                    <button
                      key={`${o.type}-${o.id}`}
                      type="button"
                      onClick={() => selectPartner(o)}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        background: 'transparent',
                        border: '1px solid #e3e8ee',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '4px',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                        color: 'inherit',
                        cursor: 'pointer'
                      }}
                    >
                      {o.nameSelect} <span style={{ fontSize: '11px', opacity: 0.6 }}>({o.type === 'agency' ? 'agência' : 'vendedor'})</span>
                    </button>
                  ))}
                {partners.filter(o => o.type === partnerMode).length === 0 && (
                  <p style={{ fontSize: '12px', opacity: 0.6, padding: '6px 2px' }}>
                    Nenhum {partnerMode === 'agency' ? 'registro de agência' : 'vendedor parceiro'} encontrado.
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
    <div className="px-4 py-2 border-b border-solid font-poppins border-lightgray">
      <p className="pb-4 font-bold">Informações do cliente</p>
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-2">
          <TextField
            className="inputRounded"
            label="E-mail"
            variant="outlined"
            type="email"
            name="email"
            value={props.client.email}
            onChange={(ev) => getClientByEmail(ev)}
            required
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div className="col-span-1">
          <TextField
            className="inputRounded"
            label="Documento de identificação"
            variant="outlined"
            type="text"
            name="document"
            value={props.client.document}
            onChange={(ev) => props.onlyLetterAndNumber(ev)}
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div className="col-span-2">
          <TextField
            className="inputRounded"
            label="Nome completo"
            variant="outlined"
            type="text"
            name="name"
            value={props.client.name}
            onChange={(ev) => props.changeClient(ev)}
            required
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div className="col-span-1">
          <PhoneMaskInput
            name="phone"
            inputClass="inputRounded"
            specialLabel="Telefone *"
            required={true}
            masks={{ cl: '. .... ....' }}
            value={props.client.phone}
            onChange={(valueNoFormated, maskInfo, target) => props.changeClient({ target: { name: 'phone', value: target.target.value } })}
          />
        </div>
      </div>
      {partnerMode === 'agency' && selectedPartner && (
        <p className="pt-3 pb-1" style={{ fontSize: '12px', opacity: 0.75 }}>
          Orçamento para agência parceira — link, contrato e cobranças vão para os dados da agência. Os dados do cliente final entram na conversão.
        </p>
      )}
    </div>
  </>
}

export default ClientForm;

const customStyles = {
  ...darkSelectStyles,
  menu: (provided, state) => ({
    ...darkSelectStyles.menu(provided, state),
    width: state.selectProps.width,
  }),
  container: (provided) => ({ ...provided, left: '-6px' }),
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: state.selectProps.width,
  }),
  valueContainer: (provided) => ({ ...provided, right: '190px' }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
}

const SearchStyle1 = {
  display: 'flex', alignItems: 'center', width: '580px',
  justifyContent: 'space-between', borderRadius: '20px',
  border: '1px solid #2a4f72', padding: '9px 10px', zIndex: '10005',
}
const SearchStyle2 = {
  display: 'flex', alignItems: 'center', width: '320px',
  justifyContent: 'space-between', borderRadius: '20px',
  border: '1px solid #2a4f72', padding: '9px 10px', zIndex: '10004',
}
const SearchStyle3 = {
  display: 'flex', alignItems: 'center', width: '320px',
  justifyContent: 'space-between', borderRadius: '20px',
  border: '1px solid #2a4f72', padding: '9px 10px', zIndex: '10003',
}

const LabelStyle = { ...darkLabelStyle, zIndex: '10005' }

const SpanSelect = {
  marginLeft: '-250px',
}